export const SOCKET_IO_BASE_URL = process.env.VUE_APP_SOCKET_IO_BASE_URL
export const DEFAULT_USERNAME = process.env.VUE_APP_DEFAULT_USERNAME
export const DEFAULT_PASSWORD = process.env.VUE_APP_DEFAULT_PASSWORD